"use strict";

exports.__esModule = true;
exports.AdvancedDataSourceContext = void 0;
var _AdvancedDataSourceController = require("./AdvancedDataSourceController");
var _Utils = require("../../../../Utils");
var AdvancedDataSourceContext = exports.AdvancedDataSourceContext = (0, _Utils.createEnhancedContext)({
  propName: "AdvancedDataSourceController",
  defaultController: _AdvancedDataSourceController.AdvancedDataSourceController
});